module.exports = __webpack_public_path__ + "static/media/pdf.45e20b2b.png";